import type { SimpleValueType, TypeDescriptor } from '@yp/common/schema/descriptor.ts';
import type { ColorScheme } from '../styles.ts';

export const DefaultScheme: ColorScheme<string> = {
  fg: '#18181b',
  bg: '#d1d5db',
  highlight: 'white',
  border: 'black',
};

// prettier-ignore
export type InputType =
  | 'button' | 'checkbox' | 'color' | 'date' | 'datetime-local' | 'email' | 'file' | 'hidden'
  | 'image' | 'month' | 'number' | 'password' | 'radio' | 'range' | 'reset' | 'search' | 'submit'
  | 'tel' | 'text' | 'time' | 'url' | 'week';

// prettier-ignore
export type InputMode =
  | 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url';

export function inputType<T extends SimpleValueType>(
  desc: TypeDescriptor<T>,
): { type: InputType; inputmode?: InputMode; pattern?: string } {
  switch (desc.t) {
    case 'string':
      switch (desc.st) {
        case 'email':
          return { type: 'email' };
        case 'phone':
          return { type: 'tel' };
        case 'numeric':
          return { type: 'text', inputmode: 'numeric', pattern: '\\d*' };
      }
      return { type: 'text' };
    case 'number':
      return { type: 'number' };
  }
  console.warn('inputType unhandled', { t: desc.t });
  return { type: 'text' };
}

export type InputStyle = 'stacked' | 'overlapped';

export const InputStyle: Record<InputStyle, { label?: string; control?: string }> = {
  stacked: {
    label: 'block text-sm/6 mb-2',
  },
  overlapped: {
    label: 'absolute z-2 -top-2 left-2 inline-block px-1 text-xs bg-base-100',
  },
};
